import {
  URL_QUERY_FEEDBACK,
  URL_QUERY_SEARCH_RESP,
  URL_UPDATE_RESPONSE_COPIED,
  URL_UPDATE_SOURCE_CLICKED,
  URL_UPDATE_TICKET_RAISED,
} from "../constants";
import { Feedback, QueryFeedback, QuerySearch, logRequest } from "../../types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../httpclient";
import { AppState } from "../../types";
export const logGenAIQueryResponse = createAsyncThunk(
  "log/queryResponse",
  async ({ ...logPayload }: logRequest,{getState}): Promise<QuerySearch> => {
    const headers = (getState() as AppState).headers;
    try {
      const payload: QuerySearch = {
        queryId: logPayload.queryId,
        sessionId: logPayload.sessionId,
        userId: logPayload.userId,
        state: logPayload.state,
        queryType: logPayload.queryType,
        query: logPayload.query,
        response: logPayload.response,
        businessUnit: logPayload.businessUnit,
        createdTimestamp: logPayload.createdTimestamp,
        respReceivedTimestamp: new Date().toISOString(),
      };
      await httpClient.post(URL_QUERY_SEARCH_RESP, payload,{headers});
      return payload;
    } catch (error) {
      throw new Error("Failed to log query search response");
    }
  }
);

interface LogFeedbackReq {
  feedback: Feedback;
}
export const logQueryFeedback = createAsyncThunk(
  "log/queryFeedback",
  async ({ feedback }: LogFeedbackReq,{getState}): Promise<void> => {
    const headers = (getState() as AppState).headers;

    try {
      const payload: QueryFeedback = {
        createdTimestamp: new Date().toISOString(),
        ...feedback,
      };
      await httpClient.post(URL_QUERY_FEEDBACK, payload,{headers});
    } catch (error) {
      throw new Error(`Failed to log query response feedback.`);
    }
  }
);

export const logSourceClicked = createAsyncThunk(
  "log/sourceClicked",
  async (queryId: string,{getState}): Promise<void> => {
    const headers = (getState() as AppState).headers;

    try {
      await httpClient.post(URL_UPDATE_SOURCE_CLICKED, { queryId: queryId },{headers});
    } catch (error) {
      throw new Error(`Failed to log isSourceClicked flag.`);
    }
  }
);

export const logResponseCopied = createAsyncThunk(
  "log/responseCopied",
  async (queryId: string,{getState}): Promise<void> => {
    const headers = (getState() as AppState).headers;

    try {
      await httpClient.post(URL_UPDATE_RESPONSE_COPIED, { queryId: queryId },{headers});
    } catch (error) {
      throw new Error(`Failed to log isResponseCopied flag.`);
    }
  }
);

export const logTicketRaised = createAsyncThunk(
  "log/ticketRaised",
  async (queryId: string,{getState}): Promise<void> => {
    const headers = (getState() as AppState).headers;
    try {
      await httpClient.post(URL_UPDATE_TICKET_RAISED, { queryId: queryId },{headers});
    } catch (error) {
      throw new Error(`Failed to log isTicketRaised flag.`);
    }
  }
);
